import { render, staticRenderFns } from "./PriceTable.vue?vue&type=template&id=27f30976&scoped=true"
import script from "./PriceTable.vue?vue&type=script&lang=js"
export * from "./PriceTable.vue?vue&type=script&lang=js"
import style0 from "./PriceTable.vue?vue&type=style&index=0&id=27f30976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f30976",
  null
  
)

export default component.exports